var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHockey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#6740E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28524 15.9099C6.48008 18.5586 8.35077 20.8168 8.35077 20.8168H12.3614L7.28524 15.9099Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9527 16.675C21.4548 16.4972 20.9694 16.3019 20.5036 16.0841C20.4628 16.0945 20.4205 16.102 20.3763 16.102L17.1538 16.1022C16.8705 16.1022 16.6412 15.8726 16.6412 15.5893C16.6412 15.3063 16.8705 15.0769 17.1538 15.0769H18.7935C18.4651 14.8308 18.1602 14.5594 17.8816 14.2598H14.9786C14.6957 14.2598 14.4663 14.0302 14.4663 13.7472C14.4663 13.4642 14.6958 13.2347 14.9786 13.2347H17.1136C16.9626 12.9799 16.8269 12.7082 16.7091 12.4177H13.7856C13.5026 12.4177 13.2731 12.1881 13.2731 11.9053C13.2731 11.622 13.5026 11.3928 13.7856 11.3928H16.346C16.2521 11.1201 16.1559 10.8478 16.0584 10.5758H12.949C12.666 10.5758 12.4364 10.3462 12.4364 10.0632C12.4364 9.77993 12.666 9.55069 12.949 9.55069H15.6838C15.2457 8.36637 14.7938 7.18579 14.3705 6L12.1674 7.61561L8.20213 7.61545C9.34991 9.45191 8.16494 13.2623 7.59277 14.8395L13.7753 20.8164H25.6793C27.6542 18.1204 23.7332 17.3105 21.9526 16.6751L21.9527 16.675Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5521 21.5651H8.5189L7.91986 23.7825C5.22446 23.8427 5 24.8107 5 24.8107V26H23.7551C27.686 25.5243 27.6486 23.6888 27.6486 23.6888L25.5521 21.5651ZM19.9988 24.5815H10.3562V22.9839H22.4426C22.4423 22.9839 22.8041 24.4799 19.9989 24.5815H19.9988Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHockey);
export default __webpack_public_path__ + "static/media/Hockey.3c1a82991738d59bc3aa6f693a50c8e1.svg";
export { ForwardRef as ReactComponent };